/**
 * Checks if the app is running on localhost
 * @returns {boolean}
 */
export function isLocalhost() {
	const hostname = window.location.hostname;
	return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1';
}

/**
 * Logs a Vue-related message to the console with consistent style
 * @param {'info'|'warn'|'error'|'success'} level - Type of log message
 * @param {string} scope - Identifier of the source (e.g., component name)
 * @param {string} message - Message to display
 */
export function log(level = 'info', scope = 'Vue', message = '') {
	if (!isLocalhost() && level !== 'warn' && level !== 'error') {
		return;
	}

	const styles = {
		info: 'color: dodgerblue; font-weight: bold;',
		warn: 'color: orange; font-weight: bold;',
		error: 'color: red; font-weight: bold;',
		success: 'color: green; font-weight: bold;',
	};

	const labelStyle = 'color: gray; font-weight: bold;';
	const scopeStyle = styles[level] || styles.info;

	console.log(`%c[Vue] %c[${scope}]%c ${message}`, labelStyle, scopeStyle, 'color: inherit;');
}
